import { render, staticRenderFns } from "./dashboarduser.vue?vue&type=template&id=ac0dd108&"
import script from "./dashboarduser.vue?vue&type=script&lang=js&"
export * from "./dashboarduser.vue?vue&type=script&lang=js&"
import style0 from "./dashboarduser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports